
<template>
  <div>
    <ul
      class="pagination"
      v-if="pagination.totalPages > 1"
    >
      <li>
        <button
          type="button"
          class="btn btn-prev"
          @click="prevPage"
          :disabled="isDisablePrevPage"
        >
          Önceki
        </button>
      </li>
      <li>
        <div
          class="form-control"
          @click="showModal"
        >
          {{ pagination.page + 1 }}
        </div>
      </li>
      <li>
        <button
          type="button"
          class="btn btn-next"
          @click="nextPage"
          :disabled="isDisableNextPage"
        >
          Sonraki
        </button>
      </li>
    </ul>
    <div
      class="pagination-modal"
      v-if="showPageModal"
      :class="{'active': pageModalActive}"
    >
      <div class="modal">
        <div class="modal-header">
          <span>Sayfa Seçimi</span>
          <span>
            <button
              class="btn btn-dark"
              @click="hideModal"
            >TAMAM</button>
          </span>
        </div>
        <div class="modal-body">
          <ul>
            <li
              v-if="pagination.page > 5"
              @click="setPage(0)"
            >
              1
            </li>
            <li
              v-if="pagination.page > 5"
              @click="setPage(pagination.page - 4)"
            >
              ...
            </li>
            <li
              v-for="page in getPages"
              :key="page"
              :class="{'active': (pagination.page) === page}"
              @click="setPage(page)"
            >
              {{ page + 1 }}
            </li>
            <li
              v-if="pagination.page < pagination.totalPages - 4"
              @click="setPage(pagination.page + 4)"
            >
              ...
            </li>
            <li
              v-if="pagination.page < pagination.totalPages - 5"
              @click="setPage(pagination.totalPages)"
            >
              {{ pagination.totalPages }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: () => {
      },
    },
  },
  data () {
    return {
      selectedPage: 0,
      showPageModal: false,
      pageModalActive: false,
    };
  },
  computed: {
    getPages () {
      const page = this.pagination.page;
      const start = (page < 5 ? 0 : page - 4);
      const end = this.pagination.totalPages > page + 4 ? page + 4 : this.pagination.totalPages - 1;
      const range = [];
      for (let num = start; num <= end; num += 1) {
        range.push(num);
      }

      return range;
    },
    isDisablePrevPage () {
      return this.pagination.page <= 0;
    },
    isDisableNextPage () {
      return this.pagination.page >= this.pagination.totalPages - 1;
    },
  },
  methods: {
    setPosition () {
      setTimeout(() => {
        const selected = document.querySelector('.pagination-modal .modal-body ul li.active');
        const list = document.querySelector('.pagination-modal .modal-body ul');
        if (selected && list) {
          list.scrollLeft = selected.offsetLeft - ((list.clientWidth - selected.clientWidth) / 2);
          this.pageModalActive = true;
        }
      }, 250);
    },
    setPage (page) {
      this.$emit('page', page);
    },
    nextPage () {
      const page = this.pagination.page >= this.pagination.totalPages - 1 ? this.pagination.totalPages - 1 : this.pagination.page + 1;
      this.setPage(page);
    },
    prevPage () {
      const page = this.pagination.page <= 0 ? 0 : this.pagination.page - 1;
      this.setPage(page);
    },
    showModal () {
      this.showPageModal = true;
      this.setPosition();
      document.body.style.overflowY = 'hidden';
    },
    hideModal () {
      this.pageModalActive = false;
      document.body.style.overflowY = '';
      setTimeout(() => {
        this.showPageModal = false;
      }, 500);
    },
  },
  watch: {
    pagination () {
      this.setPosition();
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  width: 100%;
  padding: 15px 15px 20px;
  margin: 0;
  list-style: none;

  li {
    flex: 1;
    padding-left: 15px;

    &:first-child {
      padding-left: 0;
    }
  }

  select,
  button {
    width: 100%;
    margin: 0;
  }

  .form-control {
    padding: 10px 20px;
  }

  .btn {
    font-weight: 500;
    color: #273142;
    background-color: rgb(241, 242, 247);
    border-radius: 4px;
    border: none;
    padding: 12px 0;
  }
}

.pagination-modal {
  z-index: 1;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition: all ease .1s;

  &:before {
    content: '';
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-color: rgba(39, 49, 66, .5);
    opacity: 0;
    transition: opacity ease 1s;
  }

  .modal {
    position: fixed;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;;
    transition: transform ease .5s;
    transform: translateY(100%);

    .modal-header {
      padding: 15px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      border-radius: 15px 15px 0 0;
      background-color: #f1f2f7;

      span {
        flex: 1;

        &:last-child {
          text-align: right;

          button {
            padding: 12px 0 11px;
            width: 115px;
          }
        }
      }
    }

    .modal-body {
      background-color: #ffffff;

      ul {
        margin: 0;
        padding: 50px 0;
        display: flex;
        align-items: center;
        list-style: none;
        overflow: hidden;
        overflow-x: auto;

        li {
          font-size: 22px;
          font-weight: 500;
          color: #6f7d94;
          padding: 0 22px 20px;

          &.active {
            position: relative;
            color: #f27a1a;
            font-size: 32px;

            &:before,
            &:after {
              position: absolute;
              content: '';
              display: block;
              width: 20px;
              height: 4px;
              background-color: #f27a1a;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              border-radius: 2px;
            }

            &:after {
              width: 0;
              background-color: transparent;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-bottom: 10px solid #f27a1a;
              margin-bottom: 3px;
            }
          }
        }
      }
    }
  }

  &.active {
    &:before {
      opacity: 1;
    }

    .modal {
      transform: translateY(0);
    }
  }
}
</style>
